<template>
    <dialogWrap
      v-model="show"
      title="开通支付宝支付"
      :width="'560px'"
       :before-close="() => {
        if (inResultPage) {
          return handleClose()
        }
        return show = false
       }"
    >
        <div v-if="!inResultPage">
            <el-form
                :model="form"
                :rules="rules"
                :validate-on-rule-change="false"
                :inline="true"
                label-width="200px"
                ref="formRef"
            >
                <el-form-item prop="merchantName" label="企业主体"
                >
                    <el-input
                      style="width: 220px"
                      :disabled="true"
                      v-model="form.merchantName"
                    />
                </el-form-item>
                <el-form-item prop="licenceNo" label="社会统一信用代码"
                >
                    <el-input
                      style="width: 220px"
                      :disabled="true"
                      v-model="form.licenceNo"
                    />
                </el-form-item>
                <el-form-item prop="bankShortName" label="提现到账银行名称"
                >
                    <el-input style="width: 220px" :disabled="true" v-model="form.bankShortName" />
                </el-form-item>
                <el-form-item prop="bankCardNo" label="提现到账银行账号"
                >
                    <el-input style="width: 220px" :disabled="true" v-model="form.bankCardNo" />
                </el-form-item>
                <el-form-item prop="alipayAccount" label="企业支付宝账户"
                >
                    <el-input style="width: 220px"
                    v-deleteEmoji
                    v-model="form.alipayAccount" />
                </el-form-item>
            </el-form>
        </div>
        <div v-else>
            <el-result
            :icon="errorMsg ? 'error' : 'success'"
            :title="errorMsg ? '支付宝支付开通失败' : '开通申请已提交'"
            >
                <template slot="extra">
                    <div>{{ errorMsg ? errorMsg : '请耐心等待，支付宝平台将在1-3个工作日内返回审核结果' }}</div>
                </template>
            </el-result>
        </div>
        <template slot="footer">
          <div v-if="!inResultPage">
            <el-button @click="show = false">取消</el-button>
            <el-button type="primary" @click="onSubmit">确定</el-button>
          </div>
          <div v-else>
            <el-button type="primary" @click="handleClose">我知道了</el-button>
          </div>
        </template>
    </dialogWrap>
</template>

<script setup>
import { openAlipayWithhold } from '@/api/domain/finance'
import { use$to } from '@/utils/useUtils'
import { ref, watchEffect } from 'vue'

const emit = defineEmits(['refreshList'])

const show = ref(false)
const formRef = ref(null)
const inResultPage = ref(false)
const errorMsg = ref('')

const $to = use$to()

const form = ref({
  merchantName: '',
  licenceNo: '',
  bankShortName: '',
  bankCardNo: '',
  alipayAccount: '',
  accountId: '',
})

const rules = {
  merchantName: [
    { required: true, message: '请输入企业主体', trigger: 'blur' },
  ],
  licenceNo: [
    { required: true, message: '请输入社会统一信用代码', trigger: 'blur' },
  ],
  alipayAccount: [
    { required: true, message: '请输入支付宝账号', trigger: 'blur' },
  ],
}

const showDialog = (row) => {
  inResultPage.value = false
  form.value = {
    merchantName: row.merchantName,
    licenceNo: row.licenceNo,
    bankShortName: row.bankShortName,
    bankCardNo: row.bankCardNo,
    accountId: row.accountId,
    alipayAccount: row.alipayThirdAccountNo || '', // 从现有的支付宝账户字段获取
  }
  show.value = true
}

const handleClose = () => {
  show.value = false
  emit('refreshList')
}

const onSubmit = () => {
  formRef.value.validate(async (valid) => {
    errorMsg.value = ''
    if (valid) {
      const [err, res] = await $to(openAlipayWithhold({
        corporationName: form.value.merchantName, // 接口需要的字段名
        creditCode: form.value.licenceNo, // 接口需要的字段名
        bankName: form.value.bankShortName, // 接口需要的字段名
        bankCardNo: form.value.bankCardNo,
        alipayAccount: form.value.alipayAccount,
        accountId: form.value.accountId,
      }))
      inResultPage.value = true
      if (err || res.code !== 1) {
        errorMsg.value = res.msg
      }
    }
  })
}

watchEffect(() => {
  if (!show.value) {
    inResultPage.value = false
    formRef.value?.resetFields()
  }
})

defineExpose({
  showDialog,
})

</script>
